/*
 * @Author: chengzhijie chengzhijie@eunet.cn
 * @Date: 2023-04-11 09:14:22
 * @LastEditors: chengzhijie chengzhijie@eunet.cn
 * @LastEditTime: 2024-09-02 14:25:37
 * @FilePath: \transferelectricityfront\src\utils\request.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import axios from "axios";
import { Loading, Message } from "element-ui";
import router from "@/router";
// import store from "@/store";


const request = axios.create({
  // baseURL: "http://124.70.192.24:8138/api",
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 50000,
});

let loadingInstance = 0;
request.interceptors.request.use(
  (config) => {
    // 全局Loading
    loadingInstance = Loading.service({ fullscreen: true });

    let token = sessionStorage.getItem("token");
    config.headers.token = token;

    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

request.interceptors.response.use(
  (response) => {
    // 关闭loading
    if (loadingInstance) loadingInstance.close();
    // 判断是否有权限403
    if (response.data.code == 403) {
      Message.error("无权访问，跳转中...");
      router.push("/login");
      return;
    }
    if (response.data.code == 400 && response.data.msg.includes("TOKEN过期")) {
      Message.error("TOKEN过期，请重新登录...");
      router.push("/login");
      // TODO:清除登录数据，清除token和权限数据

      return;
    }
    if (response.data.code == 401 && response.data.msg.includes("认证失败")) {
      Message.error("该账号已在其他设备登入");
      // TODO:清除登录数据，清除token和权限数据
      sessionStorage.clear() 
      // store.commit("DELETE_USERINFO");
      router.push("/login");

      return;
    }
    if (response.data.code == 500) {
      Message.error(`500-${response.data.msg}`);
      return;
    }
    return response.data;
  },
  (err) => {
    // 失败响应
    let errorObj = JSON.parse(JSON.stringify(err));
    // 关闭Loading
    if (loadingInstance) loadingInstance.close();
    // 判断失败原因
    if (errorObj.message?.includes("timeout")) {
      Message.error("网络繁忙，请刷新后重试...");
    } else if (errorObj.message?.includes("404")) {
      Message.error("大兄弟，接口地址写错了 404...");
    }
    return Promise.reject(err);
  }
);

export default request;
